import React, { useState } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import "./MemberRegistration.css";
import { insertUpdateWitnessdetails, getWitnessDeatilsByMemberId, getPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import validator from "validator";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { randomEmail, randomMobile, randomString } from "../../Helpers/Common";
import { enableTestData } from "../../Helpers/Constants/Constants";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";

const WitnessDetails = (props) => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const [data, setData] = React.useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobileNumber: null,
    email: "",
    address: "",
  });
  const [prevFirstName, setPrevFirstName] = useState();
  const [prevMiddleName, setPrevMiddleName] = useState();
  const [prevLastName, setPrevLastName] = useState();
  const [disable, setDisabled] = React.useState(false);
  const memberid = GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
 
  const { selectNextTab, selectPreviousTab } = props;
  const [error, setError] = React.useState<any>({});
  const [statusData, setStatusData] = React.useState(props?.statusData);

  React.useEffect(() => {
    getPersonalDetails();
    getWitnessDetails();
  }, []);

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    if (data.firstName == "") {
      errorObj = {
        ...errorObj,
        [data.firstName]: "This field is required",
      };
    }
    if (data.middleName == "") {
      errorObj = {
        ...errorObj,
        [data.middleName]: "This field is required",
      };
    }
    if (data.lastName == "") {
      errorObj = {
        ...errorObj,
        [data.lastName]: "This field is required",
      };
    }
    if (data.email == "") {
      errorObj = {
        ...errorObj,
        ["emailvalidation"]: "This field is required",
      };
    }
    if (data.mobileNumber == null || data.mobileNumber == undefined) {
      errorObj = {
        ...errorObj,
        [data.mobileNumber]: "This field is required",
      };
    } else if (data.mobileNumber.length != 10) {
      errorObj = {
        ...errorObj,
        [data.mobileNumber]: "Mobile number should be 10 digit",
      };
    }
    if (data.address == "") {
      errorObj = {
        ...errorObj,
        [data.address]: "This field is required",
      };
    }
    if (Object.keys(errorObj).length == 0) {
      showLoader();
      //const checkwitnessdetails = await getWitnessDetails();
      //console.log(checkwitnessdetails, "checlwitnessdetails");
      // if (
      //   checkwitnessdetails === null ||
      //   Object.keys(checkwitnessdetails).length === 0 ||
      //   checkwitnessdetails === undefined
      // ) {

      if (
        String(prevFirstName).toLocaleLowerCase() == data.firstName.toLocaleLowerCase() &&
        String(prevMiddleName).toLocaleLowerCase() == data.middleName.toLocaleLowerCase() &&
        String(prevLastName).toLocaleLowerCase() == data.lastName.toLocaleLowerCase()
      ) {
        notify(ToastType.Error, "Witness Information Must Differ from Personal Details");
        hideLoader();
        return;
      }

      let param = {
        MemberId: memberid,
        FirstName: data.firstName,
        MiddleName: data.middleName,
        LastName: data.lastName,
        ContactNo: String(data.mobileNumber),
        EmailId: data.email,
        Address: data.address,
      };
      const insertData = await APICall(insertUpdateWitnessdetails, param);
      if (insertData.Data != null) {
        hideLoader();
        selectNextTab();
      } else {
        hideLoader();
        notify(ToastType.Error, insertData.Message);
      }
      // } else {
      //   hideLoader();
      //   selectNextTab();
      // }
    }
    setError(errorObj);
  };

  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };

  const getPersonalDetails = async () => {
    showLoader();
    if (memberid != null && memberid != "") {
      let requestBody = { MemberId: memberid };
      const insertData = await APICall(getPersonalDetailsByMemberId, requestBody);
      if (insertData.Status === ApiStatus.OK && insertData.Data) {
        setPrevFirstName(insertData.Data.FirstName);
        setPrevMiddleName(insertData.Data.MiddleName);
        setPrevLastName(insertData.Data.LastName);
      }
    }
    hideLoader();
  };

  const getWitnessDetails = async () => {
    let param = `${getWitnessDeatilsByMemberId}`;
    let requestBody = { MemberId: memberid };
    const insertData = await APICall(param, requestBody);
    // return insertData.Data;
  
    if (insertData.Data != null) {
      let data = {
        firstName: insertData.Data.FirstName,
        middleName: insertData.Data.MiddleName,
        lastName: insertData.Data.LastName,
        mobileNumber: insertData.Data.ContactNo,
        email: insertData.Data.EmailId,
        address: insertData.Data.Address,
      };
      if ([ApplicationStatus.MemberRegistrationModule_Draft, ApplicationStatus.MemberRegistrationModule_RejectedHRHOD].includes(insertData.Data.StatusId)) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
      setData(data);
    }
    return insertData.Data;
  };

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    let newData = {
      firstName: randomString(10),
      middleName: randomString(10),
      lastName: randomString(10),
      mobileNumber: randomMobile(),
      email: randomEmail(),
      address: randomString(50),
    };
    setData(newData);
  };

  return (
    <div className="">
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label onDoubleClick={testData}>First Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.firstName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("firstName", value);
              }}
              isDisabled={disable}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.firstName] && <p style={{ color: "red" }}>{error[data.firstName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Middle Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.middleName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("middleName", value);
              }}
              isDisabled={disable}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.middleName] && <p style={{ color: "red" }}>{error[data.middleName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Last Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.lastName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("lastName", value);
              }}
              isDisabled={disable}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.lastName] && <p style={{ color: "red" }}>{error[data.lastName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.mobileNumber}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9\b]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  onChange("mobileNumber", value);
                }
              }}
              type="number"
              maxlength={10}
              isDisabled={disable}
              onKeyPress={(e) => handleKeyPress(e)}
              onWheel={(e) => e.target.blur()}
            />
            {error[data.mobileNumber] && <p style={{ color: "red" }}>{error[data.mobileNumber]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.email}
              onChange={(val: any) => {
                let value = val.target.value;
                if (value && !validator.isEmail(value)) {
                  setError({
                    ...error,
                    ["emailvalidation"]: "Please enter a valid email",
                  });
                } else {
                  setError({ ...error, ["emailvalidation"]: "" });
                }
                onChange("email", value);
              }}
              isDisabled={disable}
              maxLength={50}
            />
            {error["emailvalidation"] && <p style={{ color: "red" }}>{error["emailvalidation"]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>

            <label>Address</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.address}
              textArea={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("address", value);
              }}
              maxlength={200}
              isDisabled={disable}
            />
            {error[data.address] && <p style={{ color: "red" }}>{error[data.address]}</p>}
          </div>
        </div>
        <div className="p-2 d-flex justify-content-end" style={{ marginTop: 20 }}>
          <ButtonComponent icon={"fas fa-arrow-left"} value={"Back"} className="btn btn-primary btn-back" onClick={selectPreviousTab} />
          <ButtonComponent icon={"fa-solid"} value={"Exit"} style={{ marginLeft: "10px" }} className="btn btn-primary" onClick={() => navigate("/")} />
          <ButtonComponent
            icon={"fas fa-arrow-right"}
            value={disable ? "Next" : "Save & Next"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default WitnessDetails;
